/** Преобразование позиций документа к строкам таблицы */
import { toQtyNumber } from "./docQtyUtils";

export const mapDocItemsToDraw = (docItems) =>
  docItems.map((i) => ({
    ...i,
    item: i.item?.name,
    item2: i.item2?.name,
    itemcode: i.item?.code,
    measure: i.measure?.name,
    measure2: i.measure2?.name,
    pricelist: i.pricelist?.name,
    price: i.price,
    amount: toQtyNumber(i.amount, ""),
    realamount: toQtyNumber(i.realamount, ""),
    difference:
      toQtyNumber(i.amount) - toQtyNumber(i.realamount),
    total: i.total,
    salepercent: i.salepercent,
    frontprice: i.frontprice,
    itemcomment: i.itemcomment,
  }));

/** Преобразование документов к строкам таблицы */
export const mapDocumentsToDraw = (documents, moment) =>
  documents.map((d) => ({
    ...d,
    isConducted: d.ok === 1,
    number: d.docid,
    creationTime: moment(d.time).format("DD.MM.YYYY HH:mm:ss"),
    stock: d.store?.name,
    stock2: d.store2?.name,
    comment: d.comment,
  }));
